import { render } from "./OrderPartCreate.vue?vue&type=template&id=2acb626d&scoped=true"
import script from "./OrderPartCreate.vue?vue&type=script&lang=js"
export * from "./OrderPartCreate.vue?vue&type=script&lang=js"

import "./OrderPartCreate.vue?vue&type=style&index=0&id=2acb626d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acb626d"]])

export default __exports__